module.exports = __webpack_public_path__ + "static/media/promot.f36112b3.gif";